import { useState, useEffect } from "react";
import CommandsQueries from '../../../../../requests/queries/CommandsQueries'
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../../common/Loading";
import ProtectedPage from "../../../../common/ProtectedPage";
import ClientHeader from "../../../../common/ClientHeader";
import './SuccessPageStyles.css';

export default function SuccessPage({currentCommand, setCurrentCommand}) {
    
    const { id } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [command, setCommand] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        CommandsQueries.findById(id).then((res) => {
            setCommand(res.data.command);
            setIsLoading(false);
        }).catch((err) => {
            setError(err.response?.data?.message || 'An error occurred');
            setIsLoading(false);
        });
    }, [id]);

    if(isLoading) {
        return <LoadingSpinner />;
    }

    if(error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    return (
        <ProtectedPage needToBeAuthenticated={false} redirectPath="/client-auth">
            <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
            <div className="success-page-container">
                <h1>Order paid successfully</h1>
                <p className="success-page-subtitle">Order ID: {command.id}</p>
                <p className="success-page-subtitle">Date: {new Date(command.created_at).toLocaleDateString('en-GB', { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                })}</p>
                {command.products && command.products.length > 0 ? (
                    <div className="success-page-products-container">
                        {command.products.map((product) => (
                            <div className="success-page-product-card" key={product.id}>
                                <img src={product.images[0]?.image_url || 'https://via.placeholder.com/300x300?text=Image'} alt={product.name} />
                                <p className="success-page-product-name">{product.name}</p>
                                <p className="success-page-product-quantity">{product.variants?.reduce((total, variant) => total + variant.quantity, 0) || 0}</p>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="success-page-products-container">
                        <p className="success-page-subtitle">No products in this order</p>
                    </div>
                )}
            </div>
        </ProtectedPage>
    );
}